import TransitApi from './base'

export default {
  // Listar plantillas de bitácora (con sus pasos)
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/app/bitacora-templates?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Ver una plantilla
  async getById(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/app/bitacora-templates/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Crear plantilla (solo admin)
  async create(payload) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/app/bitacora-templates', payload)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Editar plantilla (solo admin). Si mandas steps, reemplaza el set completo.
  async update(id, payload) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.put(`/app/bitacora-templates/${id}`, payload)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Eliminar plantilla (solo admin)
  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/app/bitacora-templates/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
